import { Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import { Action } from '../../actions';
import { Api } from '../../typings/api';
import ApiUtils from '../../utils/api';
import { createNotification } from '../NotificationBar/actions';
import { updateDriveItemName } from '../DriveItemList/actions';

enum AssetRenamePanelActionKeys {
	OPEN_PANEL = '@@assetRenamePanel/OPEN_PANEL',
	CLOSE_PANEL = '@@assetRenamePanel/CLOSE_PANEL',
	SET_NAME = '@@assetRenamePanel/SET_NAME',
	SET_ERROR = '@@assetRenamePanel/SET_ERROR',
	SET_DRIVE_ITEM_ID = '@@assetRenamePanel/SET_DRIVE_ITEM_ID',
}

type AssetRenamePanelAction =
	OpenPanelAction |
	ClosePanelAction |
	SetNameAction |
	SetErrorAction |
	SetDriveItemIdAction;

interface OpenPanelAction extends Action {
	type: AssetRenamePanelActionKeys.OPEN_PANEL;
}

interface ClosePanelAction extends Action {
	type: AssetRenamePanelActionKeys.CLOSE_PANEL;
}

interface SetNameAction extends Action {
	type: AssetRenamePanelActionKeys.SET_NAME;
	name: string;
}

interface SetErrorAction extends Action {
	type: AssetRenamePanelActionKeys.SET_ERROR;
	error: string | null;
}

interface SetDriveItemIdAction extends Action {
	type: AssetRenamePanelActionKeys.SET_DRIVE_ITEM_ID;
	id: number;
}

const openPanel = (): OpenPanelAction => ({
	type: AssetRenamePanelActionKeys.OPEN_PANEL,
});

const setDriveItemId = (id: number): SetDriveItemIdAction => ({
	type: AssetRenamePanelActionKeys.SET_DRIVE_ITEM_ID,
	id
});

const openAssetRenamePanel = (driveItem: Api.DriveItem) => (dispatch: Dispatch<StoreState>) => {
	const { label, id } = driveItem;
	dispatch(openPanel());
	dispatch(setName(label));
	dispatch(setDriveItemId(id));
};

const closePanel = (): ClosePanelAction => ({
	type: AssetRenamePanelActionKeys.CLOSE_PANEL,
});

const setName = (name: string): SetNameAction => ({
	type: AssetRenamePanelActionKeys.SET_NAME,
	name
});

export const setError = (error: string | null): SetErrorAction => ({
	type: AssetRenamePanelActionKeys.SET_ERROR,
	error,
});

const renameAsset = (assetId: number, name: string) => async (dispatch: Dispatch<StoreState>, getState: () => StoreState): Promise<void> => {
	try {
		const {
			galleryInfos: { config: { clientId } },
		} = getState();

		const { newLabel } = await ApiUtils.renameResource(clientId, assetId, name);
		dispatch(updateDriveItemName(assetId, newLabel));
		dispatch(closePanel());
	} catch (error) {
		if (ApiUtils.isDuplicateFileNameError(error.responseText)) {
			dispatch(setError('error.duplicate_file_name'));
		} else {
			dispatch(createNotification('error.rename_asset_error'));
			dispatch(closePanel());
		}
	}
};

export {
	AssetRenamePanelActionKeys,
	AssetRenamePanelAction,
	renameAsset,
	closePanel,
	setName,
	openAssetRenamePanel,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/AssetRenamePanel/actions.ts